module.exports = require("query-string");


//////////////////
// WEBPACK FOOTER
// external "query-string"
// module id = query-string
// module chunks = 3